import { PlaceDetails } from "../types";
import { makeFlaskRequest } from "./api/apiUtils";
import { ShopifyProduct, ShopifyOrderInfo } from "../types/shopify";
import { SHOPIFY_DATA_UNAVAILABLE_MESSAGE } from "../utils/shopifyUtils";
import Environment from "environment";
import { InfluencerLocationInput } from "@foodfluence/shared";


export interface CitySuggestion {
  description: string;
  placeId: string;
}

//methods


//you have 24 hours to accept your collab

//your collab has expired

//your collab

//your content was approved/rejected

//post receivign reward reminder to post with delivera

//please remember to post your content and get verified

export const acceptCollabNotification = async (collabId: string): Promise<boolean> => {
  try {
    const result = await makeFlaskRequest<{ success: boolean }>({
      method: 'POST',
      endpoint: '/accept-collab/',
      data: {
        collab_id: collabId
      }
    });
    return result.success;
  } catch (error) {
    console.error('Error accepting collab:', error);
    return false;
  }
};

export const scheduleCollabReminder = async (
  collabId: string,
  scheduledTime: string,
  isReschedule: boolean,
  clientName: string,
  influencerHandle: string,
  influencerPhoneNumber: string,
  clientEmail: string,
  timezone: string,
  location: string,
  locationEmails: string[],
  clientID: string,
  partySize: number,
  postDueDate: string,
  isBrandReviewRequired: boolean,
  campaignType: string,
): Promise<boolean> => {
  try {
    const result = await makeFlaskRequest<{ success: boolean }>({
      method: 'POST',
      endpoint: '/schedule-collab/',
      data: {
        collab_id: collabId,
        scheduled_time: scheduledTime,
        is_reschedule: isReschedule,
        client_name: clientName,
        influencer_phone: influencerPhoneNumber,
        influencer_handle: influencerHandle,
        client_email: clientEmail,
        timezone: timezone,
        location: location,
        location_emails: locationEmails,
        client_id: clientID,
        party_size: partySize,
        post_due_date: postDueDate,
        is_brand_review_required: isBrandReviewRequired ,
        campaign_type: campaignType,
      }
    });
    return result.success;
  } catch (error) {
    console.error('Error scheduling collab reminder:', error);
    return false;
  }
};

export const getPlaceSuggestions = async (inputText: string): Promise<any[]> => {
  try {
    const result = await makeFlaskRequest<any[]>({
      method: 'GET',
      endpoint: `/places/autocomplete?input=${encodeURIComponent(inputText)}`
    });
    return result;
  } catch (error) {
    console.error('Error getting place suggestions:', error);
    return [];
  }
};

export const getCitySuggestions = async (
  inputText: string,
  lat?: number,
  lng?: number
): Promise<CitySuggestion[]> => {
  try {
    let endpoint = `/maps/city-suggestions?query=${encodeURIComponent(inputText)}`;
    if (lat !== undefined && lng !== undefined) {
      endpoint += `&lat=${lat}&lng=${lng}`;
    }
    const result = await makeFlaskRequest<{suggestions: CitySuggestion[]}>({
      method: 'GET',
      endpoint
    });
    return result.suggestions;
  } catch (error) {
    console.error('Error getting city suggestions:', error);
    return [];
  }
}

export const getPlaceDetails = async (placeId: string): Promise<PlaceDetails> => {
  try {
    const result = await makeFlaskRequest<PlaceDetails>({
      method: 'GET',
      endpoint: `/places/details?place_id=${encodeURIComponent(placeId)}`
    });
    return result;
  } catch (error) {
    console.error('Error getting place details:', error);
    return null;
  }
};

export const sendAddressSubmissionEmail = async (
  collabId: string,
  clientEmail: string,
  influencerHandle: string,
  clientID: string
): Promise<boolean> => {
  try {
    const result = await makeFlaskRequest<{ success: boolean }>({
      method: 'POST',
      endpoint: '/send-influencer-submitted-address-email/',
      data: {
        collab_id: collabId,
        client_email: clientEmail,
        influencer_handle: influencerHandle,
        client_id: clientID
      }
    });
    return result.success;
  } catch (error) {
    console.error('Error sending address submission email:', error);
    return false;
  }
};

export const sendCounterEmail = async (
  clientEmail: string,
  influencerHandle: string,
  clientID: string,
  clientName?: string
): Promise<boolean> => {
  try {
    const result = await makeFlaskRequest<{ success: boolean }>({
      method: 'POST',
      endpoint: '/influencer-countered/',
      data: {
        client_email: clientEmail,
        influencer_handle: influencerHandle,
        client_id: clientID,
        client_name: clientName
      }
    });
    return result.success;
  } catch (error) {
    console.error('Error sending counter email:', error);
    return false;
  }
};


export const cancelCollabRemindersAndNotifyClient = async (
  collabId: string,
  clientID: string,
  clientEmail: string,
  clientName: string,
  influencerHandle: string,
  influencerPhone: string
): Promise<boolean> => {
  try {
    const result = await makeFlaskRequest<{ success: boolean }>({
      method: 'POST',
      endpoint: '/cancel-collab/',
      data: {
        client_id: clientID,
        collab_id: collabId,
        client_email: clientEmail,
        client_name: clientName,
        influencer_handle: influencerHandle,
        influencer_phone: influencerPhone
      }
    });
    return result.success;
  } catch (error) {
    console.error('Error canceling collab:', error);
    return false;
  }
};

export const registerNewUser = async (userData: {
  email: string;
  firstName: string;
  lastName: string;
  instagramHandle?: string;
  tiktokHandle?: string;
  phoneNumber: string;
  locations?: InfluencerLocationInput[];
}): Promise<{success: boolean; message: string; influencerID?: string; locationsSaved?: boolean}> => {
  try {
    const result = await makeFlaskRequest<{success: boolean; message: string; influencerID?: string; locationsSaved?: boolean}>({
      method: 'POST',
      endpoint: '/influencers/register-new-user',
      data: {
        email: userData.email,
        first_name: userData.firstName,
        last_name: userData.lastName,
        instagram_handle: userData.instagramHandle || '',
        tiktok_handle: userData.tiktokHandle || '',
        phone_number: userData.phoneNumber,
        // Saved by Flask for a new creator only; locationsSaved reports the outcome.
        locations: userData.locations
      }
    });
    return result;
  } catch (error) {
    console.error('Error registering new user:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Registration failed'
    };
  }
};


/**
 * Adds handles to the influencer's profile via Flask, which validates the
 * account exists on the platform and populates follower count, engagement
 * rate, and profile picture. Throws if the handle can't be verified.
 */
export const updateInfluencerHandles = async (
  influencerId: string,
  handles: { instagramHandle?: string; tiktokHandle?: string }
): Promise<void> => {
  const clean = (handle?: string) => handle?.trim().replace('@', '').toLowerCase();
  const instagramHandle = clean(handles.instagramHandle);
  const tiktokHandle = clean(handles.tiktokHandle);
  if (!instagramHandle && !tiktokHandle) return;
  await makeFlaskRequest<{ success: boolean }>({
    method: 'POST',
    endpoint: '/influencers/update-influencer-handles',
    data: {
      influencerId,
      ...(instagramHandle && { instagramHandle }),
      ...(tiktokHandle && { tiktokHandle }),
    }
  });
};

export const messageSentToClientEmail = async (
  clientID: string,
  clientEmail: string,
  client_name: string,
  influencerHandle: string,
  message: string,
  collabId: string = ''
): Promise<boolean> => {
  try {
    const result = await makeFlaskRequest<{ success: boolean }>({
      method: 'POST',
      endpoint: '/message-sent-to-client-email/',
      data: {
        client_id: clientID,
        client_email: clientEmail,
        client_name: client_name,
        influencer_handle: influencerHandle,
        message: message,
        collab_id: collabId
      }
    });
    return result.success;
  } catch (error) {
    console.error('Error sending message sent to client email:', error);
    return false;
  }
};

export const sendExtensionRequestEmail = async (
  collabId: string,
  isCampaignFull: boolean
): Promise<boolean> => {
  try {
    const result = await makeFlaskRequest<{ success: boolean }>({
      method: 'POST',
      endpoint: '/collabs/request-extension/',
      data: {
        collab_id: collabId,
        is_campaign_full: isCampaignFull
      }
    });
    return result.success;
  } catch (error) {
    console.error('Error sending extension request email:', error);
    return false;
  }
};

export const getLocationGeohash = async (lat: string, lng: string): Promise<string> => {
  try {
    const response = await fetch(`${Environment.FLASK_HOST_URL}/influencers/get-location-geohash`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${process.env.REACT_APP_FLASK_API_KEY}`
      },
      body: JSON.stringify({
        lat: lat,
        lng: lng
      })
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result.location_geohash;
  } catch (error) {
    console.error('Error getting location geohash:', error);
    return '';
  }
};

export const getShopifyProducts = async (clientId: string, productIds: string[]): Promise<ShopifyProduct[]> => {
  try {
    const queryParams = productIds.map(id => `product_ids=${encodeURIComponent(id)}`).join('&');
    const result = await makeFlaskRequest<ShopifyProduct[]>({
      method: 'GET',
      endpoint: `/shopify/${clientId}/products/details?${queryParams}`
    });
    return result;
  } catch (error) {
    console.error('Error getting shopify products:', error);
    throw new Error(SHOPIFY_DATA_UNAVAILABLE_MESSAGE);
  }
};

export const getShopifyOrderInfo = async (
  clientId: string,
  orderId: string
): Promise<ShopifyOrderInfo> => {
  try {
    const response = await makeFlaskRequest<ShopifyOrderInfo>({
      method: 'GET',
      endpoint: `/shopify/${clientId}/orders/${orderId}`
    });

    if (!response.success) {
      throw new Error(SHOPIFY_DATA_UNAVAILABLE_MESSAGE);
    }
    return response;
  } catch (error) {
    console.error('Error getting Shopify shipping update:', error);
    return {
      success: false,
      error: SHOPIFY_DATA_UNAVAILABLE_MESSAGE,
    };
  }
};

